/*
 * Topic-driven contact form. Only the fields for the selected topic are
 * shown, enabled and required; hidden fields are disabled so they are not
 * submitted. ES5 only, and every listener is scoped to the form wrapper.
 */
(function () {
  'use strict';

  var MOUNTED = 'data-contact-support-mounted';

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function listHas(value, item) {
    if (!item) return false;
    var parts = String(value || '').split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === item) return true;
    }
    return false;
  }

  function errorTarget(control) {
    var id = control.getAttribute('data-contact-error-id');
    return id ? control.ownerDocument.getElementById(id) : null;
  }

  // Radios share one error message, so mark the whole group.
  function relatedControls(root, control) {
    if (control.type !== 'radio' || !control.name) return [control];
    var matches = [];
    each(root.querySelectorAll('input[type="radio"]'), function (radio) {
      if (radio.name === control.name) matches.push(radio);
    });
    return matches;
  }

  function setError(root, control, message) {
    var target = errorTarget(control);
    each(relatedControls(root, control), function (item) {
      if (message) item.setAttribute('aria-invalid', 'true');
      else item.removeAttribute('aria-invalid');
    });
    if (target && target.textContent !== message) target.textContent = message;
  }

  function mount(root) {
    if (!root || root.getAttribute(MOUNTED) === 'true') return;

    var topicSelect = root.querySelector('[data-contact-topic]');
    var topicGroups = root.querySelectorAll('[data-contact-topic-group]');
    if (!topicSelect || topicGroups.length === 0) return;

    var optionalFields = root.querySelectorAll('[data-contact-optional-topics]');

    function selectedTopic() {
      var option = topicSelect.options[topicSelect.selectedIndex];
      return (option && option.getAttribute('data-contact-topic-key')) || '';
    }

    function syncTopicFields() {
      var topic = selectedTopic();

      each(topicGroups, function (group) {
        var active = listHas(group.getAttribute('data-contact-topic-group'), topic);
        group.hidden = !active;

        each(group.querySelectorAll('input, select, textarea'), function (control) {
          control.disabled = !active;
          control.required = active && control.hasAttribute('data-contact-required');
          if (!active) setError(root, control, '');
        });
      });

      // Fields that are required for most topics but optional for some
      // (the general message when an art issue has its own fields).
      each(optionalFields, function (field) {
        var optional = listHas(field.getAttribute('data-contact-optional-topics'), topic);
        each(field.querySelectorAll('input, select, textarea'), function (control) {
          control.required = !optional;
        });
        each(field.querySelectorAll('[data-contact-required-mark]'), function (mark) {
          mark.hidden = optional;
        });
        each(field.querySelectorAll('[data-contact-optional-mark]'), function (mark) {
          mark.hidden = !optional;
        });
      });
    }

    // invalid does not bubble, so listen in the capture phase.
    function onInvalid(event) {
      var control = event.target;
      if (!control || !control.getAttribute || !control.getAttribute('data-contact-error-id')) return;
      setError(root, control, control.getAttribute('data-contact-error') || control.validationMessage || '');
    }

    function onEdit(event) {
      var control = event.target;
      if (!control || !control.getAttribute || !control.getAttribute('data-contact-error-id')) return;
      if (!control.validity || control.validity.valid) setError(root, control, '');
    }

    topicSelect.addEventListener('change', syncTopicFields);
    root.addEventListener('invalid', onInvalid, true);
    root.addEventListener('input', onEdit);
    root.addEventListener('change', onEdit);
    syncTopicFields();
    root.setAttribute(MOUNTED, 'true');
  }

  function init(scope) {
    scope = scope || document;
    if (scope.hasAttribute && scope.hasAttribute('data-contact-support-form')) mount(scope);
    if (scope.querySelectorAll) each(scope.querySelectorAll('[data-contact-support-form]'), mount);
  }

  init(document);

  // The script is deferred, so the form is already parsed. Cover a
  // non-deferred load too.
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  }

  // Theme editor only: re-render of this section.
  if (window.Shopify && window.Shopify.designMode) {
    window.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
